export default {"src":"/_next/static/media/filter.0a3b1bf5.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};